import { Study } from '@/shared/api/protocol-ts/model/dto_study_pb';
import { UploadSessionStatus } from '@/shared/api/protocol-ts/model/dto_upload_session_pb';

export const isStudyUploadFailed = (study: Study) =>
  study.Status === UploadSessionStatus.UploadSessionStatusFailed ||
  study.Status === UploadSessionStatus.UploadSessionStatusCancelled;
